import { useNotifications } from "../context/NotificationContext";
import { useAuth } from "../context/AuthContext";
import KOTPrintLayout from "./KOTPrintLayout";
import BillPrintLayout from "./BillPrintLayout"; // ✅ Import your existing Bill layout component
import { useNavigate } from "react-router-dom";

export default function KOTPrintTemplate() {
    const { kotPrintModal, handleKotPrint } = useNotifications();
    const { user } = useAuth();
    const navigate = useNavigate();

    if (!kotPrintModal || kotPrintModal.length === 0) return null;

    // Grab whatever print configuration job is currently up next first in line
    const currentJob = kotPrintModal[0];
    const isBill = currentJob.printType === "BILL";

    const handlePrintAndNavigate = () => {
        handleKotPrint(true);

        // ✅ If this job came from KOT_Bill_generate, navigate after printing
        if (currentJob.printType === "KOT" && currentJob.seatingName) {
            navigate(`/bill/${currentJob.seatingName}`);
        } else if (currentJob.printType === "KOT" && currentJob.tableId) {
            navigate(`/bill/${currentJob.tableId}`);
        }
    };

    return (
        <>
            {/* Screen UI Preview Modal Overlay Container Layer */}
            <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4 print:hidden">
                <div className="bg-white rounded-xl shadow-2xl p-6 w-full max-w-md">
                    <div className="flex justify-between items-center mb-4">
                        <h2 className="text-xl font-bold text-gray-900 flex items-center gap-2">
                            <span>{isBill ? "💳" : "🧾"}</span> {isBill ? "Bill Print Preview" : "KOT Print Preview"}
                        </h2>
                        <button
                            onClick={() => handleKotPrint(false)}
                            className="text-gray-400 hover:text-gray-600 transition text-2xl font-light"
                        >
                            ✕
                        </button>
                    </div>

                    {/* Metadata view header toggle */}
                    <div className="text-xs text-gray-500 mb-2 flex justify-between px-1">
                        <span><strong>Table:</strong> {currentJob.seatingName || currentJob.tableId}</span>
                        <span><strong>Type:</strong> {currentJob.printType}</span>
                    </div>

                    {/* Item list layout simulation area window */}
                    <div className="bg-gray-50 border border-gray-100 rounded-lg p-4 mb-4 max-h-60 overflow-y-auto text-sm text-gray-700">
                        {(currentJob.products || []).length === 0 ? (
                            <div className="text-center text-gray-400 py-4 italic text-xs">
                                No items found in payload window structure.
                            </div>
                        ) : (
                            <div className="space-y-3">
                                {(currentJob.products || []).map((item, idx) => {
                                    const name = item.name || item.productName || "Unknown Item";
                                    const qty = item.quantity || item.qty || 1;
                                    const price = item.price || 0;

                                    return (
                                        <div key={idx} className="flex justify-between items-start border-b border-gray-100 pb-2 last:border-0 last:pb-0">
                                            <div>
                                                <span className="font-semibold text-gray-900">{qty}x</span> {name}
                                            </div>
                                            <span className="font-medium text-gray-600">
                                                ₹{(qty * price).toFixed(2)}
                                            </span>
                                        </div>
                                    );
                                })}
                            </div>
                        )}

                        {/* If it's a Bill, show financial sub-breakdown on preview screen */}
                        {isBill && (
                            <div className="border-t border-dashed border-gray-300 pt-2 mt-2 space-y-1 text-xs text-right">
                                <div>Subtotal: ₹{currentJob.subtotal?.toFixed(2)}</div>
                                <div>GST: ₹{currentJob.totalGst?.toFixed(2)}</div>
                                <div className="font-bold text-sm text-gray-950">Grand Total: ₹{currentJob.grandTotal?.toFixed(2)}</div>
                            </div>
                        )}
                    </div>

                    {/* Button Operations */}
                    <div className="flex gap-3">
                        <button
                            onClick={() => handleKotPrint(false)}
                            className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-700 px-4 py-2.5 rounded-lg font-semibold transition"
                        >
                            Skip
                        </button>
                        <button
                            onClick={() => {
                                handlePrintAndNavigate()
                            }}
                            className="flex-1 bg-green-600 hover:bg-green-700 text-white px-4 py-2.5 rounded-lg font-semibold shadow-sm transition flex items-center justify-center gap-2"
                        >
                            Print KOT 🖨️
                        </button>
                    </div>
                </div>
            </div>

            {/* ========================================================= */}
            {/* THERMAL RECEIPT PRINT LAYER (Visible to system printer stream) */}
            {/* ========================================================= */}
            <div className="hidden print:block">
                {isBill ? (
                    <BillPrintLayout data={currentJob} />
                ) : (
                    <KOTPrintLayout data={currentJob} user={user} />
                )}
            </div>
        </>
    );
}